import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 75px; 
    }`
  }
`

const ChartProgressIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="105" height="28" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 105 28">
      <g id="chart_progress" transform="translate(-1548 -958)">
        <g id="Rectangle_2253" className="strokeHoverSVG" data-name="Rectangle 2253" transform="translate(1548 958)" fill="none" stroke="#707070" strokeWidth="3">
          <rect width="105" height="28" rx="5" stroke="none"/>
          <rect x="1.5" y="1.5" width="102" height="25" rx="3.5" fill="none"/>
        </g>
        <rect className="fillHoverSVG" id="Rectangle_2254" data-name="Rectangle 2254" width="52" height="16" rx="2" transform="translate(1554 964)" fill="#707070"/>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartProgressIcon